import { useRef, useState, useEffect } from "react";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import { toast } from "react-toastify";
import axios from "axios";
import "./SendCampaign.css";

function GetAudioAprroval() {
  const [audio, setAudio] = useState(null);
  const [fileName, setFileName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [balance, setBalance] = useState(0);
  const [showWarning, setShowWarning] = useState(false);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  var audioInputRef = useRef(0);
const theme = localStorage.getItem("theme");
document.body.className = theme;

  // Fetch user balance on component mount
  useEffect(() => {
    fetchUserBalance();
  }, []);

  const fetchUserBalance = () => {
    const token = localStorage.getItem("token");
    axios
      .get(`${BASE_URL}auth/view-profile`, {
        headers: {
          "Content-Type": "Application/json",
          version: "1.0.0",
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.data.success) {
          const userBalance = response.data.data.balance || 0;
          setBalance(userBalance);
          if (userBalance === 0) {
            setShowWarning(true);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleFileNameChange = (e) => {
    const value = e.target.value;

    if (value.length > 30) {
      setErrorMessage("File name cannot exceed 30 characters.");
    } else {
      setErrorMessage(""); // Clear the error message if valid
      setFileName(value);
    }
  };

  const OnSubmit = () => {
    // Check if user has 0 credits
    if (balance === 0) {
      toast.error("Insufficient voice credits. Please recharge your account to create audio templates.");
      return;
    }

    setLoading(true);
    if (audio == null || audio.length === 0) {
      toast.error("audio is mandatory");
      setLoading(false);
      return;
    }

    // Validation: Check file type for .mp3
    const file = audio[0];
    const allowedExtensions1 = /(\.mp3)$/i;
    if (
      !(
        allowedExtensions1.exec(file.name)
      )
    ) {
      toast.error("Only MP3 files are allowed");
      setLoading(false);
      return;
    }
    let formData = new FormData();
    formData.append("audio", audio[0]);
    formData.append("fileName", fileName);
    const token = localStorage.getItem("token");
    axios
      .post(`${BASE_URL}admin/getAudioApproval`, formData, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "multipart/form-data",
          version: "1.0.0",
        },
      })
      .then((response) => {
        setLoading(false);
        if (response.data.success == false) {
          toast.error(response.data.message);
        } else {
          toast.success(response.data.message);
          setFileName("");
          audioInputRef.current.value = null;
          setAudio(null);
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error("Upload audio file failed.. Please contact the admin");
        setLoading(false);
      });
  }; //end of OnSubmit

  return (
    <div className="send-campaign-container">
      <div className="send-campaign-card card">
        <div className="send-campaign-header card-header">
          <h6>Audio Configuration</h6> 
        </div>
        <div className="send-campaign-body card-body">
          {/* Credit Warning Banner */}
          {showWarning && (
            <div style={{
              backgroundColor: "#fff3cd",
              border: "1px solid #ffc107",
              borderRadius: "6px",
              padding: "12px 15px",
              marginBottom: "20px",
              display: "flex",
              alignItems: "center",
              gap: "10px"
            }}>
              <i className="fa fa-exclamation-triangle" style={{ color: "#856404", fontSize: "20px" }}></i>
              <div>
                <strong style={{ color: "#856404" }}>Insufficient Credits</strong>
                <p style={{ margin: "5px 0 0 0", color: "#856404", fontSize: "14px" }}>
                  You have 0 voice credits. Please recharge your account to create audio templates.
                </p>
              </div>
            </div>
          )}

          {/* Audio File name */}
          <div className="form-group-responsive">
            <label className="form-label-responsive">Audio File name :-</label>
            <input
              type="text"
              placeholder="Enter a name (defaults to file name)"
              className="form-control-responsive"
              name="fileName"
              onChange={handleFileNameChange}
              value={fileName}
            />
            {errorMessage && (
              <p style={{ color: "red", fontSize: "13px", marginTop: "5px" }}>{errorMessage}</p>
            )}
          </div>

          {/* Upload Audio */}
          <div className="form-group-responsive">
            <label className="form-label-responsive">Upload Audio:-</label>
            <input
              ref={audioInputRef}
              id="audio"
              type="file"
              className="form-control-responsive"
              name="audio"
              accept=".mp3"
              onChange={(e) => setAudio(e.target.files)}
              multiple={false}
            />
            <div style={{ fontSize: '0.75em', color: 'red', marginTop: '5px' }}>
              Only MP3 audios are accepted.
            </div>
          </div>

          {/* Submit Button */}
          <div className="submit-btn-container left-aligned">
            <button
              type="button"
              className="btn btn-primary submit-btn"
              onClick={OnSubmit}
              disabled={loading || balance === 0}
              style={balance === 0 ? { cursor: "not-allowed", opacity: 0.6 } : {}}
            >
              {loading ? (
                <>
                  <i className="fa fa-spinner fa-spin "></i>
                  <span style={{ marginLeft: "8px" }}>Uploading...</span>
                </>
              ) : (
                "Upload"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
} //end of function GetAudioAprroval

export default GetAudioAprroval;
